import { NavLink, Outlet, Link } from "react-router-dom";
import { KeyRound, Radio, Users, History, Download, FlaskConical, LogOut, ShieldCheck } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { cn } from "@/lib/utils";

const NAV = [
  { to: "/codes", label: "Codes", icon: KeyRound, id: "nav-codes" },
  { to: "/sources", label: "Sources", icon: Radio, id: "nav-sources", admin: true },
  { to: "/members", label: "Members", icon: Users, id: "nav-members", admin: true },
  { to: "/activity", label: "Activity", icon: History, id: "nav-activity" },
  { to: "/install", label: "Install extension", icon: Download, id: "nav-install" },
];

export default function Layout() {
  const { user, signOut } = useAuth();
  const items = NAV.filter((n) => !n.admin || user?.is_admin);
  return (
    <div className="flex min-h-screen">
      <aside className="hidden w-64 shrink-0 flex-col justify-between border-r border-[#242A36] bg-[#0E1117] p-4 md:flex md:sticky md:top-0 md:h-screen">
        <div>
          <Link to="/codes" className="mb-8 flex items-center gap-2.5 px-2" data-testid="brand-link">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-emerald-500 text-emerald-950">
              <ShieldCheck className="h-4.5 w-4.5" />
            </span>
            <span className="font-display text-lg font-bold tracking-tight text-zinc-100">Passcode Hub</span>
          </Link>
          <nav className="flex flex-col gap-0.5">
            {items.map(({ to, label, icon: Icon, id }) => (
              <NavLink key={to} to={to} data-testid={id} className={({ isActive }) => cn("nav-link", isActive && "active")}>
                <Icon className="h-4 w-4" />
                {label}
              </NavLink>
            ))}
            <a href="/test-login" target="_blank" rel="noreferrer" className="nav-link" data-testid="nav-test-page">
              <FlaskConical className="h-4 w-4" />
              Test page
            </a>
          </nav>
        </div>
        <div className="surface p-3">
          <p className="truncate text-sm text-zinc-200" data-testid="sidebar-user-email">{user?.email}</p>
          <p className="mt-0.5 text-[11px] uppercase tracking-wider text-zinc-500">{user?.is_admin ? "Admin" : "Member"}</p>
          <button onClick={signOut} data-testid="sign-out-button" className="mt-3 flex items-center gap-2 text-xs text-zinc-400 hover:text-zinc-100">
            <LogOut className="h-3.5 w-3.5" /> Sign out
          </button>
        </div>
      </aside>

      <div className="flex min-w-0 flex-1 flex-col">
        <header className="flex items-center justify-between border-b border-[#242A36] bg-[#0E1117] px-4 py-3 md:hidden">
          <Link to="/codes" className="font-display font-bold text-zinc-100">Passcode Hub</Link>
          <button onClick={signOut} data-testid="sign-out-button-mobile" className="text-xs text-zinc-400">Sign out</button>
        </header>
        <nav className="flex gap-1 overflow-x-auto border-b border-[#242A36] px-2 py-2 md:hidden">
          {items.map(({ to, label, id }) => (
            <NavLink key={to} to={to} data-testid={`${id}-mobile`} className={({ isActive }) => cn("nav-link whitespace-nowrap", isActive && "active")}>
              {label}
            </NavLink>
          ))}
        </nav>
        <main className="flex-1 p-4 md:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
